export default {
  compactData: {},
  compactCount: {},
  compactType: [],
  serviceContent: [],
  settlementType: [],
  busiSelectData: {},
  customSelectData: {},
  compactDetail: {},
  returndRecord: {},
  returndRecordDetail: {},
  billsRecord: {},
  billsRecordDetail: {},
  compactFileData: {},
  compactCostData: {},
  compactCostType: {},
  coprationDepartment: [],
  compactTeams: [],
  signingForm: [],
  compactSalesman: [],
  moneyBackData: [],
  costDataList: [],
  payDataList: [],
  compactPayType: [],
  spendDataList: [],
  spendSalesList: [],
  spendDetail: {},
};
